module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M31.016 4H17.648c-.826-2.326-3.024-4-5.632-4S7.208 1.674 6.382 4H1.016C.462 4 0 4.448 0 5v2c0 .552.462 1 1.016 1h5.368c.826 2.326 3.024 4 5.632 4s4.806-1.674 5.632-4h13.368A.987.987 0 0 0 32 7V5c0-.552-.432-1-.984-1zm0 20h-5.368c-.826-2.326-3.024-4-5.632-4s-4.806 1.674-5.632 4H1.016C.462 24 0 24.448 0 25v2c0 .552.462 1 1.016 1h13.368c.826 2.326 3.024 4 5.632 4s4.806-1.674 5.632-4h5.368A.987.987 0 0 0 32 27v-2c0-.552-.432-1-.984-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/slider-4.js
// module id = 1423
// module chunks = 14